import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { AppLayout } from './pages/layout.component';
import { LoginComponent } from './pages/login/login.component';
import { WildcardRedirectComponent } from './pages/wildcard-redirect.component';

export const routes: Routes = [
    {
        path: 'login',
        canActivate: [AuthGuard],
        component: LoginComponent
    },
    {
        path: '',
        component: AppLayout,
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard],
        children: [
            {
                path: 'dashboard',
                loadChildren: () => import('./routes/dashboard.routes')
            },
            {
                path: 'account',
                data: { breadcrumb: 'Account' },
                loadChildren: () => import('./routes/profile.routes')
            },
            {
                path: 'customer',
                data: { breadcrumb: 'Customer' },
                loadChildren: () => import('./routes/customer.routes')
            },
            {
                path: 'loan',
                data: { breadcrumb: 'Loan' },
                loadChildren: () => import('./routes/loan.routes')
            },
            {
                path: 'bad-debts',
                data: { breadcrumb: 'Bad Debts' },
                loadChildren: () => import('./routes/bad-debts.routes')
            },
            {
                path: 'report',
                data: { breadcrumb: 'Report' },
                loadChildren: () => import('./routes/report.routes')
            },
            {
                path: 'fund-account',
                data: { breadcrumb: 'Fund Account' },
                loadChildren: () => import('./routes/fund-account.routes')
            },
            {
                path: 'admin',
                data: { breadcrumb: 'Admin' },
                loadChildren: () => import('./routes/admin.routes')
            },
            {
                path: 'claims',
                data: { breadcrumb: 'Claims' },
                loadChildren: () => import('./routes/claim.routes')
            },
            {
                path: '**',
                component: WildcardRedirectComponent // For unknow path
            }
        ]
    }
];
